import { z } from "zod";
export const populationBriefBodySegmentSchema = z.object({
    text: z.string().min(20).max(600),
    emphasis: z.boolean().optional(),
});
export const populationBriefSectionSchema = z.object({
    overline: z.string().min(2).max(72),
    title: z.string().min(2).max(200),
    body: z.string().min(20).max(360),
});
export const populationBriefDraftSchema = z.object({
    headline: z.string().min(8).max(280),
    subtitle: z.string().min(8).max(220),
    body: z.array(populationBriefBodySegmentSchema).min(2).max(4),
    sections: z.array(populationBriefSectionSchema).length(3),
    rationale: z.string().min(20).max(800),
});
//# sourceMappingURL=operations-brief.js.map